import { render } from "./DeleteProyecto.vue?vue&type=template&id=63afeef8"
import script from "./DeleteProyecto.vue?vue&type=script&lang=js"
export * from "./DeleteProyecto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__